module.exports = __webpack_public_path__ + "img/marron-6.f6870ac3.png";